import { render } from "./home.vue?vue&type=template&id=36818026&scoped=true"
const script = {}

import "./home.vue?vue&type=style&index=0&id=36818026&scoped=true&lang=less"

import exportComponent from "E:\\a工互\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36818026"]])

export default __exports__